import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationDe from './de/translation.json'
import translationFr from './fr/translation.json'
import { DEFAULT_LANGUAGE } from "../constants";


// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  de: {
    translation: translationDe,
  },
  fr: {
    translation: translationFr,
  },
}

type availableLocales = keyof typeof resources
const locale = new Intl.Locale(document.documentElement.lang).language as availableLocales
const pageLang = resources[locale] ? locale : DEFAULT_LANGUAGE;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: pageLang, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default i18n
